<template>
<v-card flat >
  <!-- #{{relationshipId}} / {{client.id}} / {{value.id}} -->
  <template v-if='withEdit && !editOnly' >
    <v-btn
      v-if='displayMode=="view"'
      @click='displayMode="edit"'
      fab small right absolute flat >
        <v-icon>edit</v-icon>
    </v-btn>
    <v-btn v-else
      @click='displayMode="view"'
      fab small right absolute flat text ><v-icon>close</v-icon>
    </v-btn>
  </template>
  <tombstone v-if='getRequest.loading' ></tombstone>
  <template v-else >
    <template v-if='displayMode=="view"' >
      <v-list dense two-line v-if='client && client.client' >
        <h3 class='subheading ml-3' >
          <span v-if='client.client.custom_id' >[{{client.client.custom_id}}] </span>&nbsp;
          {{client.client.first_name}}
          <span v-if='client.client.nickname' >&nbsp;({{client.client.nickname}})&nbsp;</span>
          {{client.client.last_name}}
        </h3>
        <v-list-tile avatar v-if='client && client.client' @click='setMode("edit")' >
          <v-list-tile-avatar>
            <v-icon>event</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title >Email address</v-list-tile-title>
            <v-list-tile-sub-title v-if='isRealEmail(client.client.email)' >
              <a :href='"mailto:" + client.client.email' >
              {{client.client.email}}</a>
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else >
              No email address
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar v-if='client && client.client' @click='setMode("edit")' >
          <v-list-tile-avatar>
            <v-icon>sms</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title >Phone number</v-list-tile-title>
            <v-list-tile-sub-title v-if='client.client.phone_number' >
              <a :href='"tel:" + client.client.phone_number' >
                {{client.client.phone_number}}</a>
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else >
              No phone number
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action v-if='client.client' >
            <whats-app-btn :number="client.client.phone_number" />
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </template>
    <template v-else >
      <client-create
        v-if='client && client.client'
        @client:updated='clientUpdated'
        @update:loading='updateLoading'
        :relationshipId='relationshipId'
        :with-header='false'
        :context.sync='client.context'
        :initial-client='client.client' >
      </client-create>
    </template>
  </template>
  <!-- <v-progress-linear v-if='getRequest.loading' class='ma-0' height='2' indeterminate >
  </v-progress-linear> -->
</v-card>
</template>

<script>
import ClientCreate from '@/components/client/Create'
import Tombstone from '@/components/app/Tombstone'
import WhatsAppBtn from '@/components/ui/WhatsAppBtn.vue'

export default {
  name: 'ClientContactDetails',
  components: {ClientCreate, Tombstone, WhatsAppBtn},
  props: {
    value: { type: Object, default: () => { return { client: {} } } },
    relationshipId: { required: true },
    withEdit: { type: Boolean, default: false },
    editOnly: { type: Boolean, default: false },
    withFetch: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  data () {
    return {
      client: {},
      displayMode: 'view',
      reqId: 'get-relationships-request'
    }
  },
  mounted () {
    if (this.editOnly) { this.displayMode = 'edit' }
  },
  watch: {
    valueId: {
      immediate: true,
      handler () {
        this.client = {}
        if (this.value) {
          this.client = this.value
        } else {
          console.error('value changed, but it has no data .. :^/')
        }
      }
    },
    relationshipId: {
      immediate: true,
      handler () {
        if (this.withFetch && this.relationshipId) {
          this.get()
        }
      }
    },
    getRequestStatus () {
      if (this.getRequestStatus === 200 && this.remoteRelationship && this.remoteRelationship.id) {
        // this prevents a race condition
        // where an old request updates the current item
        if (this.remoteRelationship.id === this.relationshipId) {
          this.client = this.remoteRelationship
          this.$emit('relationship', this.remoteRelationship)
        }
      }
    },
    displayMode () {
      this.$emit('mode', this.displayMode)
    }
  },
  computed: {
    valueId () {
      if (this.value) { return this.value.id }
      return 0
    },
    getRequest () {
      return this.$store.getters.getRequestById(this.reqId)
    },
    getRequestStatus () {
      return this.getRequest.status
    },
    remoteRelationship () {
      return this.getObjectPath(this.getRequest, 'result.data', {})
    }
  },
  methods: {
    get () {
      if (this.relationshipId) {
        this.$appointmentguru
          .resource('practitioner.v3.relationships')
          .id(this.reqId)
          .get(this.relationshipId)
      } else {
        console.error('Could not fetch relationship. Relationship is null')
      }
    },
    clientUpdated (clientData) {
      // delete clientData['id']
      this.client = clientData
      // Object.assign(this.client.client, clientData)
      this.$emit('input', clientData)
      if (this.editOnly === true) {
        this.displayMode = 'edit'
      } else {
        this.displayMode = 'view'
      }
    },
    setMode (mode) {
      if (this.withEdit) {
        this.displayMode = mode
      }
    },
    updateLoading (loading) {
      this.$emit('update:loading', loading)
    }
  }
}
</script>

<style scoped>
.font-weight-bold{ font-weight: bold; }
</style>



// WEBPACK FOOTER //
// ClientContactDetails.vue?200af758